<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới danh mục tin tức</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">
          <el-form label-position="right" :model="modelData" ref="createModel" label-width="135px" @submit.native.prevent>
            <el-form-item prop="name" label="Tên danh mục" class="form-item"
              :rules="[
                { required: true, message: 'Vui lòng nhập tên danh mục', trigger: 'blur' }
              ]">
              <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
            </el-form-item>
            <el-form-item prop="parant_id" label="Nhóm danh mục" class="form-item"
              :rules="[
                { required: true, message: 'Vui lòng chọn nhóm danh mục', trigger: 'blur' }
              ]">
              <el-select v-model="modelData.parant_id" filterable placeholder="Chọn danh mục" class="input-select">
                <el-option
                  v-for="item in listCategories"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="priority" label="Vị trí ưu tiên" class="form-item">
              <el-input v-model="modelData.priority" class="input-seach"></el-input>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')"
                  native-type="submit">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'CategoryCreate',
  data () {
    return {
      canSubmit: true,
      modelData: {
        name: '',
        parant_id: '',
        priority: 0,
        status: true
      },
      listCategories: []
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    this.fetchListCategories()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'category-blogs-index', text: 'Danh mục tin tức' },
        { name: 'category-blogs-create', text: 'Thêm mới' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'category-blogs-index'})
    },
    // Tải dữ liệu
    fetchListCategories () {
      axios.get('category-blogs/get-recursive-category-blogs').then(response => {
        switch (response.code) {
          case 200:
            this.listCategories = response.data.categories
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          console.log('Lỗi validate')
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('category-blogs', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm danh mục thành công',
              type: 'success'
            })
            this.$router.push({name: 'category-blogs-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/category-blogs/Create.vue